// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3f790f58","404":"cd53d42b","498":"9d21fc69","787":"d718c232"}[chunkId] + ".chunk.js";
};